import "./App.css";
import { ToastContainer } from "react-toastify";
import { Route, Routes, useNavigate } from "react-router-dom";
import Layout from "./app/common/Layout";
import Login from "./app/authentications/Login";
import RequireAuth from "./app/authentications/RequireAuth";
import { useSelector } from "react-redux";
import { IUserInfo } from "./app/store/actions";
import BuildingQualityInspection from "./app/features/BuildingQualityInspection/BuildingQualityInspection";
import ElectricalFitOffInspection from "./app/features/ElectricalFitOffInspection/ElectricalFitOffInspection";
import ElectricalQualityInspection from "./app/features/ElectricalQualityInspection/ElectricalQualityInspection";
import QaQualityInspection from "./app/features/QaQualityInspection/QaQualityInspection";
import FinishingQualityInspection from "./app/features/FinishingQualityInspection/FinishingQualityInspection";
import QualityControlPlumbing from "./app/features/QCPlumbing/QCPlumbing";
import DoorDrawerQualityInspection from "./app/features/DoorDrawerInspection/DoorDrawerInspection";
import GpQualityInspection from "./app/features/GpQualityInspection/GpQualityInspection";
import FinalElectricalQualityInspection from "./app/features/FinalElectricalInspection/FinalElectricalQualityInspection";
import CleaningQualityInspection from "./app/features/CleaningQualityInspection/CleaningQualityInspection";
import QAGreenTag from "./app/features/QAGreenTag/QAGreenTag";
import Sealing from "./app/features/Sealing/Sealing";
import ComplianceInspection from "./app/features/Compliance/Compliance";
import SVIChecklist from "./app/features/SVIChecklist/SVIChecklist";
import ReworkSummaryPage from "./app/features/QCReworkSummary/ReworkSummaryPage";
import { useEffect, useMemo } from "react";
import ElectricalChassisPrep from "./app/features/QCElectricalChassisPrep/QcElectrialChassisPrep";
import { ChassisProvider } from "./app/features/ChassisNoProvider/ChassisProvider";
import IncomingChassisInspection from "./app/features/IncomingChassis/IncomingChassisInspection";
import FloorInspection from "./app/features/FloorQualityInspection/FloorInspection";
import SideWallsInspection from "./app/features/SideWallsQualityInspection/SideWallsInspection";
import RoofAndJMouldInspection from "./app/features/RoofInspection/RoofInspection";
import JMouldInspection from "./app/features/JMouldAssembly/JMouldInspection";
import PostBuildingQualityInspection from "./app/features/PostBuildingQualityInspection/PostBuildingQualityInspection";
import FurnitureQualityInspection from "./app/features/FurnitureQualityInspection/FurnitureQualityInspection";
import ElectricalBmsInspection from "./app/features/ElectricalBMS/ElectricalBmsInspection";
import CreateUserPage from "./app/pages/Admin/CreateUserPage";
import UserManagementPage from "./app/pages/Admin/UserManagementPage";

function App() {
  const navigate = useNavigate();
  const authInfo: IUserInfo = useSelector(
    (state: any) => state.userAuthInfoState
  );
  const roleToPath = useMemo(() => {
    const mapping: Record<string, string[]> = {
      "chassis-elec-qa": ["/electrical-chassis-prep"],
      furniture_prep: ["/furniture-quality-inspection"],
      "builder-qc": [
        "/building-quality-inspection",
        "/post-building-quality-inspection",
      ],
      "electrical-qc": [
        "/electrical-bms-quality-inspection",
        "/electrical-fit-off-quality-inspection",
        "/electrical-quality-inspection",
        "/electrical-final-quality-inspection",
        "/rework-summary",
      ],
      cleaning: ["/cleaning-quality-inspection"],
      "quality-assurance": [
        "/qa-quality-inspection",
        "/post-building-quality-inspection",
        "/finishing-quality-inspection",
        "/qa-green-tag",
        "/sealing-quality-inspection",
        "/cleaning-quality-inspection",
        "/gp12-quality-inspection",
        "/svi-checklist",
        "/rework-summary",
      ],
      "sealing": ["/sealing-quality-inspection"],
      "j-mould": ["/j-mould-quality-inspection"],
      floor_and_lino_assembly: ["/floor-quality-inspection"],
      wall_assembly_prep: ["/side-walls-quality-inspection"],
      roof_assembly_prep: ["/roof-quality-inspection"],
      chassis_prep: ["/incoming-chassis-quality-inspection"],
      doors_and_drawers_prep: ["/doors-drawers-benchtops-quality-inspection"],
      plumber: ["/quality-control-plumbing"],
      compliance: ["/compliance-quality-inspection"],
      "line-manager-qc": [
        "/electrical-chassis-prep",
        "/furniture-quality-inspection",
        "/building-quality-inspection",
        "/post-building-quality-inspection",
        "/electrical-bms-quality-inspection",
        "/electrical-fit-off-quality-inspection",
        "/electrical-quality-inspection",
        "/qa-quality-inspection",
        "/quality-control-plumbing",
  "/finishing-quality-inspection",
  "/doors-drawers-benchtops-quality-inspection",
  "/qa-green-tag",
  "/sealing-quality-inspection",
  "/compliance-quality-inspection",
  "/electrical-final-quality-inspection",
  "/cleaning-quality-inspection",
  "/gp12-quality-inspection",
        "/svi-checklist",
        "/incoming-chassis-quality-inspection",
        "/floor-quality-inspection",
        "/side-walls-quality-inspection",
        "/roof-quality-inspection",
        "/j-mould-quality-inspection",
        "/rework-summary",
      ],
      "qa-manager-qc": [
        "/electrical-chassis-prep",
        "/furniture-quality-inspection",
        "/building-quality-inspection",
        "/post-building-quality-inspection",
        "/electrical-bms-quality-inspection",
        "/electrical-fit-off-quality-inspection",
        "/electrical-quality-inspection",
        "/qa-quality-inspection",
        "/quality-control-plumbing",
  "/finishing-quality-inspection",
  "/doors-drawers-benchtops-quality-inspection",
  "/qa-green-tag",
  "/sealing-quality-inspection",
  "/compliance-quality-inspection",
  "/electrical-final-quality-inspection",
  "/cleaning-quality-inspection",
  "/gp12-quality-inspection",
        "/svi-checklist",
        "/incoming-chassis-quality-inspection",
        "/floor-quality-inspection",
        "/side-walls-quality-inspection",
        "/roof-quality-inspection",
        "/j-mould-quality-inspection",
        "/rework-summary",
      ],
    };

    const adminPaths = Array.from(
      new Set([
        ...Object.values(mapping).flat(),
        "/create-user",
        "/user-management",
      ])
    );

    mapping.admin = adminPaths;
    return mapping;
  }, []);

  useEffect(() => {
    if (authInfo?.roles?.length > 0) {
  const currentPath = globalThis.location?.pathname ?? "/";

      const accessiblePaths = authInfo.roles
        .map((role) => roleToPath[role] ?? [])
        .filter((paths) => paths.length > 0);

      const flattenedAccessiblePaths = Array.from(
        new Set(accessiblePaths.flat())
      );
      if (!flattenedAccessiblePaths.includes(currentPath)) {
        const firstAccessiblePath = flattenedAccessiblePaths[0];
        if (firstAccessiblePath) {
          navigate(firstAccessiblePath, { replace: true });
        }
      }
    }
  }, [authInfo, navigate, roleToPath]);

  const hasRole = (role: string) =>
    authInfo?.roles?.includes("admin") || authInfo?.roles?.includes(role);

  return (
    <>
      <ChassisProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Layout />}>
            <Route element={<RequireAuth />}>
              {(hasRole("chassis-elec-qa") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/electrical-chassis-prep"
                  element={<ElectricalChassisPrep />}
                />
              )}
              {(hasRole("furniture_prep") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/furniture-quality-inspection"
                  element={<FurnitureQualityInspection />}
                />
              )}
              {(hasRole("chassis_prep") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/incoming-chassis-quality-inspection"
                  element={<IncomingChassisInspection />}
                />
              )}
              {(hasRole("floor_and_lino_assembly") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/floor-quality-inspection"
                  element={<FloorInspection />}
                />
              )}
              {(hasRole("wall_assembly_prep") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/side-walls-quality-inspection"
                  element={<SideWallsInspection />}
                />
              )}
              {(hasRole("roof_assembly_prep") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/roof-quality-inspection"
                  element={<RoofAndJMouldInspection />}
                />
              )}
              {(hasRole("j-mould") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/j-mould-quality-inspection"
                  element={<JMouldInspection />}
                />
              )}
              {(hasRole("builder-qc") ||
                hasRole("line-manager-qc") ||
                hasRole("cleaning") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/building-quality-inspection"
                  element={<BuildingQualityInspection />}
                />
              )}
              {(hasRole("quality-assurance") ||
                hasRole("builder-qc") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/post-building-quality-inspection"
                  element={<PostBuildingQualityInspection />}
                />
              )}
              {(hasRole("electrical-qc") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/electrical-bms-quality-inspection"
                  element={<ElectricalBmsInspection />}
                />
              )}
              {(hasRole("electrical-qc") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/electrical-fit-off-quality-inspection"
                  element={<ElectricalFitOffInspection />}
                />
              )}
              {(hasRole("electrical-qc") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/electrical-quality-inspection"
                  element={<ElectricalQualityInspection />}
                />
              )}
              {(hasRole("quality-assurance") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/qa-quality-inspection"
                  element={<QaQualityInspection />}
                />
              )}

              {(hasRole("plumber") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/quality-control-plumbing"
                  element={<QualityControlPlumbing />}
                />
              )}
              {(hasRole("quality-assurance") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/finishing-quality-inspection"
                  element={<FinishingQualityInspection />}
                />
              )}
              {(hasRole("doors_and_drawers_prep") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/doors-drawers-benchtops-quality-inspection"
                  element={<DoorDrawerQualityInspection />}
                />
              )}
              {(hasRole("quality-assurance") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route path="/qa-green-tag" element={<QAGreenTag />} />
              )}
              {(hasRole("sealing") ||
                hasRole("quality-assurance") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/sealing-quality-inspection"
                  element={<Sealing />}
                />
              )}
              {(hasRole("compliance") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/compliance-quality-inspection"
                  element={<ComplianceInspection />}
                />
              )}
              {(hasRole("electrical-qc") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/electrical-final-quality-inspection"
                  element={<FinalElectricalQualityInspection />}
                />
              )}
              {(hasRole("quality-assurance") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc") ||
                hasRole("cleaning")) && (
                <Route
                  path="/cleaning-quality-inspection"
                  element={<CleaningQualityInspection />}
                />
              )}
              {(hasRole("quality-assurance") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route
                  path="/gp12-quality-inspection"
                  element={<GpQualityInspection />}
                />
              )}
              {(hasRole("quality-assurance") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc")) && (
                <Route path="/svi-checklist" element={<SVIChecklist />} />
              )}

              {(hasRole("quality-assurance") ||
                hasRole("line-manager-qc") ||
                hasRole("qa-manager-qc") ||
                hasRole("electrical-qc")) && (
                <Route path="/rework-summary" element={<ReworkSummaryPage />} />
              )}
              {hasRole("admin") && (
                <Route path="/create-user" element={<CreateUserPage />} />
              )}
              {hasRole("admin") && (
                <Route path="/user-management" element={<UserManagementPage />} />
              )}
            </Route>
          </Route>
        </Routes>
      </ChassisProvider>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;
